import { SnowflakeIcon } from './SnowflakeIcon';

/**
 * author: Google
 * id 5675A747-D467-473E-9A1D-1C61E1B5C619
 * name snowflake
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snowflake.svg
 * tags
 * - Weather 
 * - Holiday 
 * - Automotive 
 */
export const PowerHibernateIcon = SnowflakeIcon;
export default PowerHibernateIcon